// import React, { useEffect, useState } from "react";
// import { Slider, Spin } from "antd";
// import { LoadingOutlined } from "@ant-design/icons";
// import "./ScaleFactor.css";

// const ScaleFactor = ({ warehouseScaleFactor = 0, onChange, loading }) => {
//   const [scaleFactor, setScaleFactor] = useState(1);

//   const onChangeScaleFactor = (value) => {
//     setScaleFactor(value);
//     onChange(value);
//   };
//   useEffect(() => {
//     setScaleFactor(warehouseScaleFactor * 100);
//   }, [warehouseScaleFactor]);

//   return (
//     <div className="scale-factor">
//       <h5 className="scale-factor-title">Scale Factor</h5>
//       <Slider min={1} max={100} step={1} value={scaleFactor} onChange={onChangeScaleFactor} />
//       {loading && (
//         <div className="scale-factor-loading-text">
//           Please wait <Spin indicator={<LoadingOutlined spin />} size="small" />
//         </div>
//       )}
//     </div>
//   );
// };

// export default ScaleFactor;

import React, { useEffect, useState } from "react";
import { Slider, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import "./ScaleFactor.css";

const ScaleFactor = ({ warehouseScaleFactor = 0, onChange, loading, zoomValue, setZoomValue }) => {
  const [scaleFactor, setScaleFactor] = useState(150); // Start at 100% zoom

  // Logarithmic conversion for better zoom experience
  const getDisplayValue = (actualValue) => {
    // Convert 150-1000 to 1-100 using log scale
    const minActual = 150;
    const maxActual = 1000;
    const minDisplay = 1;
    const maxDisplay = 100;

    const logMin = Math.log(minActual);
    const logMax = Math.log(maxActual);
    const logValue = Math.log(actualValue);

    // the least value should be 1% and the highest value should be 100%
    return Math.max(minDisplay, Math.min(maxDisplay, Math.round(minDisplay + ((logValue - logMin) * (maxDisplay - minDisplay)) / (logMax - logMin))));
  };

  const getActualValue = (displayValue) => {
    const minDisplay = 1;
    const maxDisplay = 100;
    const minActual = 150;
    const maxActual = 1000;

    const logMin = Math.log(minActual);
    const logMax = Math.log(maxActual);

    const logValue = logMin + ((displayValue - minDisplay) * (logMax - logMin)) / (maxDisplay - minDisplay);

    return Math.max(minActual, Math.min(maxActual, Math.round(Math.exp(logValue))));
  };

  const onChangeScaleFactor = (displayValue) => {
    const actualValue = getActualValue(displayValue);
    setScaleFactor(actualValue);
    setZoomValue(actualValue);
    onChange(actualValue);
  };

  useEffect(() => {
    if (zoomValue !== undefined) {
      setScaleFactor(zoomValue);
    }
  }, [zoomValue]);

  return (
    <div className="scale-factor">
      <h5 className="scale-factor-title">Scale Factor</h5>
      <Slider
        min={1}
        max={100}
        step={1} // Smaller steps for smoother control
        value={getDisplayValue(scaleFactor)}
        onChange={onChangeScaleFactor}
        disabled={loading}
      />
      <div className="zoom-percentage">{getDisplayValue(scaleFactor)}%</div>
      {loading && (
        <div className="scale-factor-loading-text">
          Please wait <Spin indicator={<LoadingOutlined spin />} size="small" />
        </div>
      )}
    </div>
  );
};

export default ScaleFactor;
